/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedTechnologyList,
  PatchedTechnology,
  Technology,
} from '../models/index';
import {
    PaginatedTechnologyListFromJSON,
    PaginatedTechnologyListToJSON,
    PatchedTechnologyFromJSON,
    PatchedTechnologyToJSON,
    TechnologyFromJSON,
    TechnologyToJSON,
} from '../models/index';

export interface TechnologiesAssetsListRequest {
    assetId: number;
    assetType: string;
    teamSlug: string;
}

export interface TechnologiesAssetsRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface TechnologiesCreateRequest {
    teamSlug: string;
    technology: Omit<Technology, 'id'|'assets_count'>;
}

export interface TechnologiesDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface TechnologiesListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
}

export interface TechnologiesPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedTechnology?: Omit<PatchedTechnology, 'id'|'assets_count'>;
}

export interface TechnologiesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface TechnologiesUpdateRequest {
    id: string;
    teamSlug: string;
    technology: Omit<Technology, 'id'|'assets_count'>;
}

/**
 * 
 */
export class TechnologiesApi extends runtime.BaseAPI {

    /**
     * Get technologies for a specific asset
     */
    async technologiesAssetsListRaw(requestParameters: TechnologiesAssetsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Technology>>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling technologiesAssetsList().'
            );
        }

        if (requestParameters['assetType'] == null) {
            throw new runtime.RequiredError(
                'assetType',
                'Required parameter "assetType" was null or undefined when calling technologiesAssetsList().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesAssetsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/assets/{asset_type}/{asset_id}/`.replace(`{${"asset_id"}}`, encodeURIComponent(String(requestParameters['assetId']))).replace(`{${"asset_type"}}`, encodeURIComponent(String(requestParameters['assetType']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TechnologyFromJSON));
    }

    /**
     * Get technologies for a specific asset
     */
    async technologiesAssetsList(requestParameters: TechnologiesAssetsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Technology>> {
        const response = await this.technologiesAssetsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all assets using this technology
     */
    async technologiesAssetsRetrieveRaw(requestParameters: TechnologiesAssetsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Technology>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling technologiesAssetsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesAssetsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/{id}/assets/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnologyFromJSON(jsonValue));
    }

    /**
     * Get all assets using this technology
     */
    async technologiesAssetsRetrieve(requestParameters: TechnologiesAssetsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Technology> {
        const response = await this.technologiesAssetsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async technologiesCreateRaw(requestParameters: TechnologiesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Technology>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesCreate().'
            );
        }

        if (requestParameters['technology'] == null) {
            throw new runtime.RequiredError(
                'technology',
                'Required parameter "technology" was null or undefined when calling technologiesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TechnologyToJSON(requestParameters['technology']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnologyFromJSON(jsonValue));
    }

    /**
     */
    async technologiesCreate(requestParameters: TechnologiesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Technology> {
        const response = await this.technologiesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async technologiesDestroyRaw(requestParameters: TechnologiesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling technologiesDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async technologiesDestroy(requestParameters: TechnologiesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.technologiesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async technologiesListRaw(requestParameters: TechnologiesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTechnologyList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTechnologyListFromJSON(jsonValue));
    }

    /**
     */
    async technologiesList(requestParameters: TechnologiesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTechnologyList> {
        const response = await this.technologiesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async technologiesPartialUpdateRaw(requestParameters: TechnologiesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Technology>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling technologiesPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedTechnologyToJSON(requestParameters['patchedTechnology']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnologyFromJSON(jsonValue));
    }

    /**
     */
    async technologiesPartialUpdate(requestParameters: TechnologiesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Technology> {
        const response = await this.technologiesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async technologiesRetrieveRaw(requestParameters: TechnologiesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Technology>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling technologiesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnologyFromJSON(jsonValue));
    }

    /**
     */
    async technologiesRetrieve(requestParameters: TechnologiesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Technology> {
        const response = await this.technologiesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async technologiesUpdateRaw(requestParameters: TechnologiesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Technology>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling technologiesUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling technologiesUpdate().'
            );
        }

        if (requestParameters['technology'] == null) {
            throw new runtime.RequiredError(
                'technology',
                'Required parameter "technology" was null or undefined when calling technologiesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/technologies/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TechnologyToJSON(requestParameters['technology']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TechnologyFromJSON(jsonValue));
    }

    /**
     */
    async technologiesUpdate(requestParameters: TechnologiesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Technology> {
        const response = await this.technologiesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
